import type { RemovableRef } from "@vueuse/core";
import type { ContentCardModel } from "@/models/ContentCard";

export default (
  contentId: string,
  cached: RemovableRef<RecommendSessionStorage>,
  contents: globalThis.Ref<
    {
      id: string;
      bannerImage: string;
      titleTH: string;
    }[],
    | ContentCardModel[]
    | {
        id: string;
        bannerImage: string;
        titleTH: string;
      }[]
  >,
  contentShows: globalThis.Ref<
    {
      id: string;
      bannerImage: string;
      titleTH: string;
    }[],
    | ContentCardModel[]
    | {
        id: string;
        bannerImage: string;
        titleTH: string;
      }[]
  >,
) => {
  if (!cached.value) {
    cached.value = {
      [contentId]: {
        contents: contents.value,
        contentShows: contentShows.value,
      },
    };
  } else {
    cached.value[contentId] = {
      contents: contents.value,
      contentShows: contentShows.value,
    };
  }
};
